module.exports = __webpack_public_path__ + "static/t2-0d2f2de229582d3800cebacfd5f3dd9e.svg";